import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from "@angular/core";

@Directive({
  selector: "[clickInside]",
})
export class ClickInsideDirective implements OnInit {
  @Output() clickInsideDatepicker = new EventEmitter<any>();

  constructor(private elementRef: ElementRef) {}
  ngOnInit(): void {}

  @HostListener("document:click", ["$event.target"])
  public onClick(targetElement: EventTarget) {
    const clickInside = this.elementRef.nativeElement.contains(targetElement);
    if (clickInside) {
      this.clickInsideDatepicker.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/date-picker/click-inside.directive.ts